module.exports = __webpack_public_path__ + "img/phone-calendar.ea71b6cd.webp";